













import ViewBase from '@/utils/ViewBase'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class Main extends ViewBase {
  @Prop() copyright: any
  @Prop() linkList: any
}
